import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import env from './env';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) { }

  getToday(){
    return this.http.get<any>(env.url+"/website/result?today=true")
    .pipe(map(data =>{
      return data;
    }))
  }
}
